import Joi from '@hapi/joi';
import { UpdatePasswordValues } from 'types';
import validate from './validate';
import { userNameRules, passwordRules, passwordLessRules } from './utils/common';

export const schema = Joi.object<UpdatePasswordValues>({
  userName: userNameRules(),
  password: passwordLessRules(),
  newPassword: passwordRules(),
  confirmNewPassword: Joi.string()
    .valid(Joi.ref('newPassword'))
    .messages({
      'any.only': 'PASSWORD_CONFIRM',
      'string.empty': 'PASSWORD_CONFIRM',
    })
    .required(),
});

export default function (value: Partial<UpdatePasswordValues>) {
  return validate(schema, value, {
    allowUnknown: false,
    context: {},
  });
}
